import React from 'react';
import cx from 'classnames';
import Linkify from 'react-linkify';

const ActionBox = ({ className, children }) =>
    <div className={cx("action", className)}>
        {children}
    </div>
;

const Dot = ({ children }) =>
    <div className="action-dot">
        {children}
    </div>
;

const Content = ({ children }) =>
    <div className="action-content">
        {children}
    </div>
;

const Date = ({ children }) =>
    <div className="date">
        {children}
    </div>
;

const Action = ({ children }) =>
    <div className="action-message">
        {children}
    </div>
;

const Author = ({ children }) =>
    <span className="admin-name">
        {children}
    </span>
;

const MessageAuthor = ({ children }) =>
    <span className="message-author">
        {children}
    </span>
;

const MessageContent = ({ children }) => <>
    {children && <Linkify componentDecorator={(decoratedHref, decoratedText, key)=><a className="cursor-pointer text-orange-500 underline" target='_blank' href={decoratedHref} key={key}>
        {decoratedText}
    </a>}>
        <p className="whitespace-break-spaces">
            {children}
        </p>
    </Linkify>}
</>
;

export {
    ActionBox,
    Dot,
    Content,
    Date,
    Author,
    Action,
    MessageAuthor,
    MessageContent
};
